export const DEFAULT_AVATAR = '/assets/img/default_avatar.png';
